import type { EntityType, Vector2 } from '../../odie';
import { Container, createEntity, DefineEntity, Entity2D } from '../../odie';

import { PositionComponent } from '../components/PositionComponent';
import { TileComponent } from '../components/TileComponent';
import { config } from '../defs/config';
import type { GameScene } from '../GameScene';

// types
//-----------------------------------------------------------------------------
const TileEntityDef = DefineEntity(Entity2D, PositionComponent, TileComponent);

export type TileEntity = EntityType<typeof TileEntityDef>;

// factory
//-----------------------------------------------------------------------------
export function spawnTileEntity(
  scene: GameScene,
  position: Vector2,
): TileEntity | null {
  // Create the tile map first, will be null if empty
  const tileMap = TileComponent.createTileMap(
    scene.sessionEntity.c.map.mapDef,
    position,
  );

  if (!tileMap) return null;

  // create container
  const container = new Container();
  container.tag = `TILE[${position.x},${position.y}]`;
  container.width = config.tile.size;
  container.height = config.tile.size;

  // create entity
  const entity = createEntity(TileEntityDef, {
    view2d: { view: container, layer: 'back' },
    position: { position },
    tile: { mapDef: scene.sessionEntity.c.map.mapDef, position, tileMap },
  });

  // set interactive
  entity.c.view2d.view.interactive = true;

  // initialize scene
  if (entity.c.tile.container) {
    container.addChild(entity.c.tile.container);
  }
  // add to scene
  scene.addToScene(entity);

  // add to map
  scene.sessionEntity.c.map.setTileEntity(entity, position);

  return entity;
}

export function despawnTileEntity(scene: GameScene, entity: TileEntity) {
  // remove from scene
  scene.removeFromScene(entity);
}
